import styled from "styled-components";

const Info = styled.span`
  font-size: 1.4rem;
  color: ${props => props.theme.colors.grey};
  margin-left: 1rem;
`;

export default Info;
